import React from "react";
import Jumbotron from "../Components/Jumbotron/Jumbotron";
import Navbar from "../Components/Navbar/Navbar";
import AboutTraining from "../Components/AboutTraining/AboutTraining";
import Benefit from "../Components/Benefit/Benefit";
import Gallery from "../Components/Gallery/Gallery";
import Alumni from "../Components/Alumni/Alumni";
import PaketBelajar from "../Components/PaketBelajar/PaketBelajar";
import SectionDaftar from "../Components/SectionDaftar/SectionDaftar";
import Fasilitas from "../Components/Fasilitas/Fasilitas";
import Cta from "../Components/Cta/Cta";
import Video from "../Components/Video/Video";
import Testimoni from "../Components/Testimoni/Testimoni";
import MasterTeacher from "../Components/MasterTeacher/MasterTeacher";
import Liputan from "../Components/Liputan/Liputan";
import CtaBottom from "../Components/CtaBottom/CtaBottom";
import Footer from "../Components/Footer/Footer";
import FloatCta from "../Components/FloatCta/FloatCta";
import { Helmet } from "react-helmet-async";
import TargetBelajar from "../Components/TargetBelajar/TargetBelajar";
import Materi from "../Components/Materi/Materi";
import PopUp from "../Components/PopUp/PopUp";
import HalDitanyakan from "../Components/HalDitanyakan/HalDitanyakan";

const Home = () => {
  return (
    <React.Fragment>
      <Helmet>
        <meta
          charSet="utf-8"
          name="description"
          content="Layanan Terbaik, Program Terlengkap & Instruktur Professional. Promo 5%! Daftar sekarang | Bimbel Masuk TNI Polri- Akpol, Sipss, Bintara, Tamtama. #1 Akademik, Psikologi, Bimjas"
        />
        <title>
          Bimbel Akpol Akademi TNI Bintara TNI POLRI dan Sekolah Kedinasan
          Terbaik - Taruna Persada
        </title>
        <link rel="canonical" href="https://camp.tarunapersada.com/" />
      </Helmet>

      <Navbar />
      {/* <PopUp /> */}
      <Jumbotron />
      <AboutTraining />
      <Benefit />
      <Alumni />
      <TargetBelajar />
      <PaketBelajar />
      <SectionDaftar />
      <Gallery />
      <Fasilitas />
      {/* <Cta /> */}
      <Materi />
      <Video />
      <Testimoni />
      <HalDitanyakan />
      <MasterTeacher />
      <Liputan />
      <CtaBottom />
      <Footer />
      <FloatCta />
    </React.Fragment>
  );
};

export default Home;
